import Theme from '../theme';

/**
 * Returns true if we are in a small viewport
 */
export function isNarrowViewport(width = window.innerWidth) {
  return width < Theme.grid.breakpoints.md * 16;
}

export function noop() {}
